module.exports = __webpack_public_path__ + "media/images/message-bf14b1dc87854ca0d2b6f556f131df06.svg";